function isPlainObject(value: unknown): value is object {
  if (typeof value !== "object" || value === null) return false;
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
}

/**
 * Value equality for decoded JSON: plain objects, arrays, primitives and dates.
 * Any other class instance (Map, Set, ...) is equal only to itself, so a wrong
 * answer can only cost a re-render, never hide a change.
 * Рівність за значенням для розкодованого JSON; решта класів рівні лише собі.
 */
export function structurallyEqual(a: unknown, b: unknown): boolean {
  if (Object.is(a, b)) return true;
  if (a instanceof Date) return b instanceof Date && a.getTime() === b.getTime();
  if (Array.isArray(a)) {
    return (
      Array.isArray(b) && a.length === b.length && a.every((v, i) => structurallyEqual(v, b[i]))
    );
  }
  if (!isPlainObject(a) || !isPlainObject(b) || Array.isArray(b)) return false;
  const keys = Object.keys(a);
  return (
    keys.length === Object.keys(b).length &&
    keys.every(
      (key) => Object.hasOwn(b, key) && structurallyEqual(Reflect.get(a, key), Reflect.get(b, key)),
    )
  );
}

/**
 * State updater helper: a poll that returns the same data must not hand React
 * a new reference, or every memoized consumer below re-renders for nothing.
 * Опитування з тими самими даними не повинно віддавати React нове посилання.
 */
export function keepIfEqual<T>(previous: T, next: T): T {
  return structurallyEqual(previous, next) ? previous : next;
}
